import { createI18n } from "vue-i18n";
import zh from "./locales/zh.json";
import en from "./locales/en.json";

const messages = {
  zh: {
    ...zh,
  },
  en: {
    ...en,
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "zh", // 首选语言
  fallbackLocale: "zh", // 备选语言
  globalInjection: true,
  messages,
  datetimeFormats: {
    zh: {
      short: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      },
      medium: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      },
      full: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        weekday: "long",
      },
    },
    en: {
      short: {
        year: "2-digit",
        month: "2-digit",
        day: "numeric",
      },
      medium: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      },
      long: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      },
      full: {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        weekday: "long",
        second: "numeric",
      },
    },
  },
});

export default i18n;
